/**
 * Section impression names for /wedding-seating.
 *
 * Same reasoning as the four sibling pages' `sections.js`: `trackSectionViewed`
 * is section-name-agnostic, but the shared analytics module documents its
 * supported values as a closed set with a named wrapper per value, and that
 * module is vendored byte-identical into invite/ and app/ (guarded by
 * `npm run verify:analytics`). Page-local constants keep the "one owner per
 * string, never a literal at a call site" rule without editing two other apps
 * to instrument a landing-page section.
 *
 * No new analytics EVENT is introduced here — `section_view` already exists and
 * these are its `section` parameter values, exactly as on the siblings.
 *
 * Six impressions, not fourteen — the same restraint the siblings exercise. The
 * pipeline the whole positioning rests on (reply → guest list → reception
 * guests → tables), the trust section that is the real differentiator (a seat
 * is never emptied on the couple's behalf), the offer, the plan qualifier, the
 * questions and the close. Enough to see where a search visitor stops without
 * turning the funnel report into noise; the editorial sections in between are
 * one continuous argument and splitting them would measure scroll depth, not
 * interest.
 */
export const WSE_SECTION = {
  FLOW: "wedding_seating_flow",
  CHANGES: "wedding_seating_changes",
  DEMO: "wedding_seating_demo",
  PLAN: "wedding_seating_plan",
  FAQ: "wedding_seating_faq",
  FINAL_CTA: "wedding_seating_final_cta",
};

export default WSE_SECTION;
